import ListFilters from '@/common/components/ListFilters'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { CompanyBranchData } from '@/common/types/companyBranches.type'
import { useEstablishmentCompanies } from '@/features/establishments/hooks/useEstablishmentCompanies'
import { EstablishmentCompanyTransformer } from '@/features/establishments/services/establishmentCompanyTransformer'
import { useAvailableCompanyBranches } from '@/features/privateCompanies/hooks/companyBranches/useAvailableCompanyBranches'

type FilterProps = {
  companyId?: string
}

const Filters = ({ companyId }: FilterProps) => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [companyBranchSearch, setCompanyBranchSearch] = useDebounce('')
  const [searchEstablishmentBranch, setSearchEstablishmentBranch] = useDebounce('')

  const { data: establishmentBranchOptions } = useEstablishmentCompanies({
    filters: { search: searchEstablishmentBranch },
    mapper: Mapper.mapWithTransformer({ transformer: EstablishmentCompanyTransformer.optionTransformer() }),
  })

  const { data: clientCompanyBranchOptions } = useAvailableCompanyBranches({
      companyId,
    filters: {
      search: companyBranchSearch,
    },
    mapper: Mapper.mapToOptions<CompanyBranchData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  })

  return (
    <div className="flex gap-x-2 z-50">
      <ListFilters
        filters={[
          {
            className: 'min-w-56',
            onChange: (establishmentCompany) => setFilterParams((prev) => ({ ...prev, establishmentCompany })),
            value: filterParams.establishmentCompany,
            onInputChange: (value) => setSearchEstablishmentBranch(value),
            options: [{ label: 'Todas', value: '' }, ...(establishmentBranchOptions || [])],
            placeholder: 'Estabelecimento',
          },

          {
            className: 'min-w-56',
            onChange: (branch) => setFilterParams((prev) => ({ ...prev, branch })),
            value: filterParams.branch,
            onInputChange: (e) => setCompanyBranchSearch(e),
            options: [{ label: 'Todas', value: '' }, ...(clientCompanyBranchOptions || [])],
            placeholder: 'Filial',
          },
        ]}
      />
    </div>
  )
}

export default Filters
